export const SCHEMA_ORG_BASE_URL = 'https://schema.org';

export const SCHEMA_PUBLISHER_CONFIG = {
  NAME: 'Nebula',
  TYPE: 'Spiritual Platform',
  LOGO_URL: '/images/logo-dark.svg',
  LANGUAGE: 'en',
} as const;

export const SCHEMA_TYPES = {
  ARTICLE: `${SCHEMA_ORG_BASE_URL}/Article`,
  VIDEO_OBJECT: `${SCHEMA_ORG_BASE_URL}/VideoObject`,
  IMAGE_OBJECT: `${SCHEMA_ORG_BASE_URL}/ImageObject`,
  PERSON: `${SCHEMA_ORG_BASE_URL}/Person`,
  ORGANIZATION: `${SCHEMA_ORG_BASE_URL}/Organization`,
  BREADCRUMB_LIST: `${SCHEMA_ORG_BASE_URL}/BreadcrumbList`,
  LIST_ITEM: `${SCHEMA_ORG_BASE_URL}/ListItem`,
  PLACE: `${SCHEMA_ORG_BASE_URL}/Place`,
  OFFER: `${SCHEMA_ORG_BASE_URL}/Offer`,
  PROPERTY_VALUE: `${SCHEMA_ORG_BASE_URL}/PropertyValue`,
  AGGREGATE_RATING: `${SCHEMA_ORG_BASE_URL}/AggregateRating`,
  BRAND: `${SCHEMA_ORG_BASE_URL}/Brand`,
  PRODUCT: `${SCHEMA_ORG_BASE_URL}/Product`,
} as const;

export const SCHEMA_ITEM_PROPS = {
  ADDITIONAL_PROPERTY: 'additionalProperty',
  AUTHOR: 'author',
  CONTENT_URL: 'contentUrl',
  DATE_MODIFIED: 'dateModified',
  DATE_PUBLISHED: 'datePublished',
  DESCRIPTION: 'description',
  EMBED_URL: 'embedUrl',
  HEADLINE: 'headline',
  IMAGE: 'image',
  IN_LANGUAGE: 'inLanguage',
  ITEM_LIST_ELEMENT: 'itemListElement',
  JOB_TITLE: 'jobTitle',
  LOGO: 'logo',
  MAIN_ENTITY_OF_PAGE: 'mainEntityOfPage',
  NAME: 'name',
  OFFERS: 'offers',
  PRICE: 'price',
  PRICE_CURRENCY: 'priceCurrency',
  PUBLISHER: 'publisher',
  REVIEWED_BY: 'reviewedBy',
  THUMBNAIL_URL: 'thumbnailUrl',
  UPLOAD_DATE: 'uploadDate',
  URL: 'url',
  VALUE: 'value',
  WORK_LOCATION: 'workLocation',
} as const;
